export const ChartColors = {
  negativeChange: '#bc1c0e',
  positiveChange: '#167922',
  neutral: '#4368bd',
  panelBg: '#dadde3',
  text: '#414752',
  othersBg: '#dadde3',
};

export const HIDE_LABELS_DATASET_SIZE = 26;
export const CHART_DEFAULT_HEIGHT = 583;
export const CHART_HEIGHT_ADDITIONAL_SUMMARY = 643;
export const CHART_TITLE_HEIGHT = 40; // segmentation chart allocate h-10 for title which is 40px
